import { Typography, typographyClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledGreeting = styled(Typography)(({ theme }) => ({
  [`&.${typographyClasses.root}`]: {
    fontSize: theme.typography.pxToRem(20),
    color: theme.palette.lwBlack[100],
    fontVariationSettings: '"wght" 600',
    lineHeight: '20px',
  },
}));
